import { ITenantTreeTenant } from '../interfaces/tenant-tree-tenant.interface';
import { ETenantProfile } from '@insolution/graphql-data-access';

const tenantTreeMockBase = {
  profile: ETenantProfile.A,
  disabled: false,
  children: [],
};

export const tenantTreeMock: ITenantTreeTenant = {
  ...tenantTreeMockBase,
  id: 'parent1',
  name: 'Tenant Parent 1',
  tenant_ref: 'parent1.',
  workshop_milling_tenant_ref: 'milling-workshop-parent1.milling-workshop1.',
  workshop_milling_tenant_id: 'milling-workshop1',
  workshop_milling_tenant_name: 'Name of milling-workshop1',
  workshop_printing_tenant_ref: 'printing-workshop-parent1.printing-workshop1.',
  workshop_printing_tenant_id: 'printing-workshop1',
  workshop_printing_tenant_name: 'Name of printing-workshop1',
  isParent: true,
  parent_id: null,
  children: [
    {
      ...tenantTreeMockBase,
      id: 'parent2',
      name: 'Tenant Parent 2',
      tenant_ref: 'parent1.parent2.',
      workshop_milling_tenant_ref: 'milling-workshop-parent1.milling-workshop1.',
      workshop_milling_tenant_id: 'milling-workshop1',
      workshop_milling_tenant_name: 'Name of milling-workshop1',
      workshop_printing_tenant_ref: 'printing-workshop-parent1.printing-workshop1.',
      workshop_printing_tenant_id: 'printing-workshop1',
      workshop_printing_tenant_name: 'Name of printing-workshop1',
      isParent: true,
      parent_id: 'parent1',
      children: [
        {
          ...tenantTreeMockBase,
          id: 'parent3',
          name: 'Tenant Parent 3',
          tenant_ref: 'parent1.parent2.parent3.',
          workshop_milling_tenant_ref: 'milling-workshop-parent1.milling-workshop1.',
          workshop_milling_tenant_id: 'milling-workshop1',
          workshop_milling_tenant_name: 'Name of milling-workshop1',
          workshop_printing_tenant_ref: 'printing-workshop-parent1.printing-workshop1.',
          workshop_printing_tenant_id: 'printing-workshop1',
          workshop_printing_tenant_name: 'Name of printing-workshop1',
          isParent: true,
          disabled: false,
          parent_id: 'parent2',
          children: [
            {
              ...tenantTreeMockBase,
              id: 'parent5',
              name: 'Tenant Parent 5',
              tenant_ref: 'parent1.parent2.parent3.parent5.',
              workshop_milling_tenant_ref: 'milling-workshop-parent1.milling-workshop1.',
              workshop_milling_tenant_id: 'milling-workshop1',
              workshop_milling_tenant_name: 'Name of milling-workshop1',
              workshop_printing_tenant_ref: 'printing-workshop-parent1.printing-workshop1.',
              workshop_printing_tenant_id: 'printing-workshop1',
              workshop_printing_tenant_name: 'Name of printing-workshop1',
              isParent: true,
              disabled: false,
              parent_id: 'parent3',
              children: [
                {
                  ...tenantTreeMockBase,
                  id: '2',
                  name: 'Tenant 2',
                  parent_id: 'parent5',
                  tenant_ref: 'parent1.parent2.parent3.parent5.2.',
                  workshop_milling_tenant_ref: 'milling-workshop-parent1.milling-workshop1.',
                  workshop_milling_tenant_id: 'milling-workshop1',
                  workshop_milling_tenant_name: 'Name of milling-workshop1',
                  workshop_printing_tenant_ref: 'printing-workshop-parent1.printing-workshop1.',
                  workshop_printing_tenant_id: 'printing-workshop1',
                  workshop_printing_tenant_name: 'Name of printing-workshop1',
                  children: [],
                },
              ],
            },
            {
              ...tenantTreeMockBase,
              id: '5',
              name: 'Tenant 5',
              parent_id: 'parent3',
              tenant_ref: 'parent1.parent2.parent3.5.',
              workshop_milling_tenant_ref: 'milling-workshop-parent1.milling-workshop1.',
              workshop_milling_tenant_id: 'milling-workshop1',
              workshop_milling_tenant_name: 'Name of milling-workshop1',
              workshop_printing_tenant_ref: 'printing-workshop-parent1.printing-workshop1.',
              workshop_printing_tenant_id: 'printing-workshop1',
              workshop_printing_tenant_name: 'Name of printing-workshop1',
            },
          ],
        },
        {
          ...tenantTreeMockBase,
          id: 'parent4',
          name: 'Tenant Parent 4',
          isParent: true,
          parent_id: 'parent2',
          tenant_ref: 'parent1.parent2.parent4.',
          workshop_milling_tenant_ref: 'milling-workshop-parent1.milling-workshop1.',
          workshop_milling_tenant_id: 'milling-workshop1',
          workshop_milling_tenant_name: 'Name of milling-workshop1',
          workshop_printing_tenant_ref: 'printing-workshop-parent1.printing-workshop1.',
          workshop_printing_tenant_id: 'printing-workshop1',
          workshop_printing_tenant_name: 'Name of printing-workshop1',
          children: [
            {
              ...tenantTreeMockBase,
              id: '3',
              name: 'Tenant 3',
              parent_id: 'parent4',
              tenant_ref: 'parent1.parent2.parent4.3.',
              workshop_milling_tenant_ref: 'milling-workshop-parent1.milling-workshop1.',
              workshop_milling_tenant_id: 'milling-workshop1',
              workshop_milling_tenant_name: 'Name of milling-workshop1',
              workshop_printing_tenant_ref: 'printing-workshop-parent1.printing-workshop1.',
              workshop_printing_tenant_id: 'printing-workshop1',
              workshop_printing_tenant_name: 'Name of printing-workshop1',
            },
            {
              ...tenantTreeMockBase,
              id: '4',
              name: 'Tenant 4',
              parent_id: 'parent4',
              tenant_ref: 'parent1.parent2.parent4.4.',
              workshop_milling_tenant_ref: 'milling-workshop-parent1.milling-workshop1.',
              workshop_milling_tenant_id: 'milling-workshop1',
              workshop_milling_tenant_name: 'Name of milling-workshop1',
              workshop_printing_tenant_ref: 'printing-workshop-parent1.printing-workshop1.',
              workshop_printing_tenant_id: 'printing-workshop1',
              workshop_printing_tenant_name: 'Name of printing-workshop1',
            },
          ],
        },
      ],
    },
  ],
};
